import React from 'react';
import { MenuItem as MenuItemMaterial } from '@material-ui/core';

const MenuItem = React.forwardRef(({ children, ...rest }, ref) => {
  return <MenuItemMaterial {...rest}>{children}</MenuItemMaterial>;
});

export default MenuItem;
